import {
	RSVP_LOOKUP_INITIATED,
	RSVP_LOOKUP_FAILED,
	RSVP_LOOKUP_SUCCEEDED,
	RSVP_RESPONSE_INITIATED,
	RSVP_RESPONSE_FAILED,
	RSVP_RESPONSE_SUCCEEDED
} from '../actions/RsvpActions';

const initialState = {
  looking: false,
  found: false,
	responding: false,
	responded: false,
	invitation: null,
  failure: false
};

export const RsvpReducer = (state = initialState, action) => {
  switch(action.type) {
    case RSVP_LOOKUP_INITIATED:
      return {
        ...state,
				looking: true,
				failure: false
      };
		case RSVP_LOOKUP_FAILED:
      return {
        ...state,
				found: false,
				looking: false,
				failure: true
      };
		case RSVP_LOOKUP_SUCCEEDED:
      return {
        ...state,
				found: true,
				looking: false,
				failure: false,
				invitation: action.payload
      };
		case RSVP_RESPONSE_INITIATED:
      return {
        ...state,
				looking: false,
				failure: false,
				responding: true,
				responded: false
      };
		case RSVP_RESPONSE_FAILED:
      return {
        ...state,
				looking: false,
				failure: true,
				responding: false,
				responded: false
      };
		case RSVP_RESPONSE_SUCCEEDED:
      return {
        ...state,
				looking: false,
				failure: false,
				responding: false,
				responded: true
      };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./state/reducers/RsvpReducer.js